import { Action, VehicleActions } from './vehicle-actions';
import { tassign } from 'tassign';
import { VehicleState, initialVehicleState } from './vehicle-state.model';

/**
* @function VehicleReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
* @return {tassing<VehicleState>} Value with the store
**/
export const VehicleReducer = function (state: VehicleState = initialVehicleState, action: Action): VehicleState {
  switch (action.type) {
    case VehicleActions.SET_VEHICLES:
      return tassign(state, { vehicles: action.payload.vehicles });
    case VehicleActions.RESET_VEHICLESTORE:
      return initialVehicleState;
    case VehicleActions.SET_REMOTE_DETAILS:
      return tassign(state, { remote: action.payload });
    default:
      return state;
  }
};


